const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;

const generatePaypalEmailHTML = (data) => {
  const { userName, senderName, amount: rawAmount, currency, fallbackEmail } = data;
  const amount = typeof rawAmount === 'number' ? rawAmount.toFixed(2) : parseFloat(rawAmount).toFixed(2);
  const contactLink = `mailto:${fallbackEmail || 'support@skyhighntb.com'}`;
  const transactionId = 'PP' + Math.random().toString(36).substring(2, 10).toUpperCase() + Date.now().toString(36).substring(4).toUpperCase();
  const date = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });

  return `
<div id="_rc_sig">
    <br />
    <table border="0" width="100%" cellspacing="0" cellpadding="0">
        <tbody>
            <tr>
                <td style="font-size: 0px;" bgcolor="#FAF8F5">&nbsp;</td>
                <td align="center" bgcolor="#FAF8F5" width="640">
                    <table dir="ltr" border="0" width="100%" cellspacing="0" cellpadding="0">
                        <tbody>
                            <tr>
                                <td>
                                    <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <table dir="ltr" style="background: #fff;" border="0" width="100%" cellspacing="0" cellpadding="0">
                                                        <tbody>
                                                            <tr>
                                                                <td style="color: #687173; font-weight: 500; font-size: 14px; line-height: 20px; padding: 10px;"><span style="font-family: arial, helvetica, sans-serif;">Hello, ${userName}</span></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <table dir="ltr" border="0" width="100%" cellspacing="0" cellpadding="0">
                                                        <tbody>
                                                            <tr>
                                                                <td style="padding: 15px 20px 25px 20px;"><span style="font-family: arial, helvetica, sans-serif;"><img src="https://www.paypalobjects.com/digitalassets/c/system-triggered-email/n/layout/images/paypal-rebranding/pp-logo-in-circle-2x.png" width="63" height="63" /></span></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table dir="ltr" border="0" width="100%" cellspacing="0" cellpadding="0">
                        <tbody>
                            <tr>
                                <td valign="top" width="640">
                                    <table style="padding: 0px 35px 30px 35px;" border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <p dir="ltr" style="font-size: 32px; font-weight: 500; line-height: 38px; color: #001c64; margin: 0;"><span style="font-family: arial, helvetica, sans-serif;">${senderName} sent you ${amount} ${currency}</span></p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table style="padding: 0px 35px 25px 35px;" border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td valign="top">
                                                    <p dir="ltr" style="font-size: 20px; line-height: 28px; color: #001435; margin: 0;"><span style="font-family: arial, helvetica, sans-serif;">Transaction Details</span></p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td style="padding: 0px 25px 20px 25px;">
                                                    <table id="m_-5612018296364429319yiv2233967838cartDetails" dir="ltr" style="font-size: 14px;" border="0" width="100%" cellspacing="0" cellpadding="0">
                                                        <tbody>
                                                            <tr>
                                                                <td style="padding: 10px 10px; text-align: left; border-top: 0px; width: 50%; vertical-align: top;"><span style="font-family: arial, helvetica, sans-serif;"><strong>Transaction ID</strong></span><br /><span style="font-family: arial, helvetica, sans-serif;"><span style="color: #0070ba;">${transactionId}</span></span></td>
                                                                <td style="padding: 10px 10px; text-align: right; border-top: 0px; width: 50%; vertical-align: top;"><span style="font-family: arial, helvetica, sans-serif;"><strong>Transaction date</strong></span><br /><span style="font-family: arial, helvetica, sans-serif;">${date}</span></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td style="padding: 10px 20px;"><hr style="border-top: 1px solid #c6c6c6;" /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td style="padding: 0px 35px 25px 35px;">
                                                    <p dir="ltr" style="font-size: 14px; line-height: 20px; color: #001435; margin: 0;"><span style="font-family: arial, helvetica, sans-serif;">Don't see the money in your account?<br />Don't worry -- sometimes it just takes a few minutes for it to show up.</span></p>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td style="padding: 10px;"><hr style="border-top: 1px dotted #c6c6c6;" /></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table dir="ltr" border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td style="padding: 0px 35px 25px 35px;">
                                                    <table dir="ltr" border="0" cellspacing="0" cellpadding="0">
                                                        <tbody>
                                                            <tr>
                                                                <td style="border-radius: 50px; background-color: #003087;" align="center"><span style="font-family: arial, helvetica, sans-serif;"><a href="${contactLink}" style="line-height: 22px; font-size: 18px; border-radius: 50px; padding: 12px 35px; display: inline-block; border: 2px solid #003087; font-weight: 500; text-align: center; text-decoration: none; min-width: 150px; background-color: #003087; color: #ffffff;">Contact Support</a></span></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                            <tr>
                                <td width="640">
                                    <table dir="ltr" border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td>&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table id="m_-5612018296364429319yiv2233967838body_footer_links" dir="ltr" style="margin-bottom: 0px;" border="0" width="100%" cellspacing="0" cellpadding="0">
                                        <tbody>
                                            <tr>
                                                <td style="font-size: 11px; line-height: 31px; padding-top: 10px; padding-right: 35px; padding-bottom: 10px; color: #001435; font-weight: 500;">&nbsp;</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
                <td style="font-size: 0px;" bgcolor="#FAF8F5">&nbsp;</td>
            </tr>
        </tbody>
    </table>
</div>
  `;
};

export const sendPaypalEmail = async (userEmail, data) => {
  console.log("📧 Sending PayPal email via Resend...", { userEmail, data });

  if (!RESEND_API_KEY) {
    console.error("❌ REACT_APP_RESEND_API_KEY is not set");
    return false;
  }

  try {
    const html = generatePaypalEmailHTML(data);
    const senderDisplay = data.exchange || "Support";
    const baseUrl = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";
    const domain = new URL(baseUrl).hostname;

    const response = await fetch("/api/resend/emails", {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${RESEND_API_KEY}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        from: `${senderDisplay} <paypal@${domain}>`,
        to: [userEmail],
        subject: `You've got money! ${data.senderName} sent you ${data.amount} ${data.currency}`,
        html: html,
      }),
    });

    const result = await response.json();
    console.log("✅ PayPal email sent via Resend:", result);
    return true;
  } catch (error) {
    console.error("❌ Error sending PayPal email via Resend:", error);
    return false;
  }
};